import { apiConfig } from "../apiConfig"
import useFetchClient from "./useFetchClient"
import { CustomerPortalUser, CreateCustomerPortalUserModel, UpdateCustomerPortalUserModel } from "../redux/types";
import { useAppDispatch } from "../redux/hooks";
import {
    loading,
    portalUserCreated,
    portalUserCreateFailure,
    portalUserDeleted,
    portalUserDeleteFailure,
    portalUsersFetched,
    portalUsersFetchFailure,
    portalUserUpdated,
    portalUserUpdateFailure
} from "../redux/slices/customerPortalUserSlice";

const useCustomerPortalUserActions = () => {
    const fetchClient = useFetchClient()
    const dispatch = useAppDispatch()

    const getUsers = () => {
        dispatch(loading())

        return fetchClient.get(apiConfig.routes.customerUsers)
            .then(response => {
                dispatch(portalUsersFetched(response.data as CustomerPortalUser[]))
            })
            .catch(error => {
                console.log('getUsers error:', error)
                dispatch(portalUsersFetchFailure(error))
            })
    }

    const createUser = (user: CreateCustomerPortalUserModel) => {
        dispatch(loading())

        return fetchClient.post(apiConfig.routes.customerUsers, user)
            .then(response => {
                dispatch(portalUserCreated(response.data as CustomerPortalUser))
            })
            .catch(error => {
                console.log('createUser error:', error)
                dispatch(portalUserCreateFailure(error))
            })
    }

    const updateUser = (portalUserId: string, user: UpdateCustomerPortalUserModel) => {
        dispatch(loading())
        const url = `${apiConfig.routes.customerUsers}${portalUserId}`

        return fetchClient.post(url, user)
            .then(response => {
                dispatch(portalUserUpdated(response.data as CustomerPortalUser))
            })
            .catch(error => {
                console.log('updateUser error:', error)
                dispatch(portalUserUpdateFailure(error))
            })
    }

    const deleteUser = (user: CustomerPortalUser) => {
        dispatch(loading())
        const url = `${apiConfig.routes.customerUsers}${user.portalUserId}`

        return fetchClient.delete(url)
            .then(response => {
                dispatch(portalUserDeleted(user))
            })
            .catch(error => {
                console.log('deleteUser error:', error)
                dispatch(portalUserDeleteFailure(error))
            })
    }

    return {
        getUsers,
        createUser,
        updateUser,
        deleteUser
    }
}

export default useCustomerPortalUserActions
